import { loadPantheon } from '@data/content-loaders';
import type { DivinityEntry } from '@data/schemas/pantheon';
import { normalize } from '@features/search';
import { html } from 'lit';

export async function renderReligionsPage(): Promise<unknown> {
  const pantheon = await loadPantheon();

  const matches = (d: DivinityEntry, q: string): boolean =>
    normalize(`${d.nom} ${d.domaines.join(' ')} ${d.capacite_divine.label}`).includes(q);

  const render = (d: DivinityEntry) => html`
    <div class="list-card">
      <span class="list-card-badge">${d.domaines.join(', ')}</span>
      <span class="list-card-title">${d.nom}</span>
      <span class="list-card-sub">Arme sacree : ${d.arme_sacree}</span>
      <span class="list-card-meta">
        ${d.capacite_divine.label}${d.capacite_divine.voie_source ? ` (${d.capacite_divine.voie_source})` : ''}
      </span>
    </div>
  `;

  return html`
    <div class="list-page">
      <header class="list-page-header">
        <h1 class="list-page-title" data-morph data-morph-duration="1500">Religions d'Osgild</h1>
        <p class="list-page-subtitle">${pantheon.divinites.length} divinites. Le pretre specialiste choisit une divinite pour obtenir une capacite divine specifique.</p>
      </header>
      <cof2-search-grid
        .items=${pantheon.divinites}
        .predicate=${matches}
        .renderItem=${render}
        placeholder="Rechercher une divinite (nom, domaine, capacite)..."
      ></cof2-search-grid>
    </div>
  `;
}
